/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResearchPromptStatus } from './ResearchPromptStatus';
import {
    ResearchPromptStatusFromJSON,
    ResearchPromptStatusFromJSONTyped,
    ResearchPromptStatusToJSON,
} from './ResearchPromptStatus';
import type { ResearchPromptResult } from './ResearchPromptResult';
import {
    ResearchPromptResultFromJSON,
    ResearchPromptResultFromJSONTyped,
    ResearchPromptResultToJSON,
} from './ResearchPromptResult';
import type { SearchRequestV3 } from './SearchRequestV3';
import {
    SearchRequestV3FromJSON,
    SearchRequestV3FromJSONTyped,
    SearchRequestV3ToJSON,
} from './SearchRequestV3';

/**
 * A prompt used in the research process
 * @export
 * @interface ResearchPrompt
 */
export interface ResearchPrompt {
    /**
     * 
     * @type {number}
     * @memberof ResearchPrompt
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ResearchPrompt
     */
    researchSessionId: string;
    /**
     * 
     * @type {string}
     * @memberof ResearchPrompt
     */
    prompt?: string;
    /**
     * 
     * @type {number}
     * @memberof ResearchPrompt
     */
    totalNumberOfResults?: number;
    /**
     * 
     * @type {Array<SearchRequestV3>}
     * @memberof ResearchPrompt
     */
    requests?: Array<SearchRequestV3>;
    /**
     * A summary of all results
     * @type {string}
     * @memberof ResearchPrompt
     */
    resultsSummary?: string;
    /**
     * 
     * @type {Array<ResearchPromptResult>}
     * @memberof ResearchPrompt
     */
    results: Array<ResearchPromptResult>;
    /**
     * 
     * @type {ResearchPromptStatus}
     * @memberof ResearchPrompt
     */
    status: ResearchPromptStatus;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResearchPrompt
     */
    followupSuggestions: Array<string>;
    /**
     * The plan for the research prompt
     * @type {Array<string>}
     * @memberof ResearchPrompt
     */
    plan?: Array<string>;
    /**
     * The current step in the plan. 0 means it is planning.
     * @type {number}
     * @memberof ResearchPrompt
     */
    currentStep?: number;
}

/**
 * Check if a given object implements the ResearchPrompt interface.
 */
export function instanceOfResearchPrompt(value: object): value is ResearchPrompt {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('researchSessionId' in value) || value['researchSessionId'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('followupSuggestions' in value) || value['followupSuggestions'] === undefined) return false;
    return true;
}

export function ResearchPromptFromJSON(json: any): ResearchPrompt {
    return ResearchPromptFromJSONTyped(json, false);
}

export function ResearchPromptFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResearchPrompt {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'researchSessionId': json['research_session_id'],
        'prompt': json['prompt'] == null ? undefined : json['prompt'],
        'totalNumberOfResults': json['total_number_of_results'] == null ? undefined : json['total_number_of_results'],
        'requests': json['requests'] == null ? undefined : ((json['requests'] as Array<any>).map(SearchRequestV3FromJSON)),
        'resultsSummary': json['results_summary'] == null ? undefined : json['results_summary'],
        'results': ((json['results'] as Array<any>).map(ResearchPromptResultFromJSON)),
        'status': ResearchPromptStatusFromJSON(json['status']),
        'followupSuggestions': json['followup_suggestions'],
        'plan': json['plan'] == null ? undefined : json['plan'],
        'currentStep': json['current_step'] == null ? undefined : json['current_step'],
    };
}

export function ResearchPromptToJSON(value?: ResearchPrompt | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'research_session_id': value['researchSessionId'],
        'prompt': value['prompt'],
        'total_number_of_results': value['totalNumberOfResults'],
        'requests': value['requests'] == null ? undefined : ((value['requests'] as Array<any>).map(SearchRequestV3ToJSON)),
        'results_summary': value['resultsSummary'],
        'results': ((value['results'] as Array<any>).map(ResearchPromptResultToJSON)),
        'status': ResearchPromptStatusToJSON(value['status']),
        'followup_suggestions': value['followupSuggestions'],
        'plan': value['plan'],
        'current_step': value['currentStep'],
    };
}

